// react
import React from 'react'

// css
import './LastEditedInsights.scss'

// dependencies
import { Link } from 'react-router-dom'
import { Button, BUTTON_SIZE, BUTTON_THEME, Card, Icon } from '@st-operations/uikit/src/v2/index.js'
import ListView from '_components/list-view/index.jsx'
import ItemInfoCell from '_components/item-info-cell/index.jsx'

// libraries
import format from '@st-operations/uikit/lib/format.js'

class LastEditedInsights extends React.Component {
  search = (sort_dir, sort_key, filters, next) => {
    let { all_reports, sortAudience } = this.props
    sortAudience(sort_key, sort_dir, true)

    // filter
    if (filters.created_by) {
      all_reports = all_reports.filter((item) => item.created_by === filters.created_by.value)
    }
    next(all_reports)
  }

  render() {
    let { page_size, all_reports, user_reports } = this.props

    // get filter options by created by
    let options = all_reports && [
      ...new Set(
        all_reports
          .map((report) => {
            return report.created_by
          })
          .sort((a, b) => (a > b ? 1 : -1))
      ),
    ]

    return (
      <div className="last-edited-insights">
        <h2 className="last-edited-insights__title">Last edited by you</h2>
        <div className="last-edited-insights__reports">
          <If condition={user_reports && user_reports.length > 0}>
            <For each="report" index="index" of={user_reports}>
              <Card key={index} className="last-edited-insights__report">
                <Link
                  className="last-edited-insights__report-link"
                  key={report.href}
                  to={report.href}
                >
                  <p className="last-edited-insights__prefix">{report.parent}</p>
                  <p className="last-edited-insights__name">{report.label}</p>
                  <div className="last-edited-insights__size">
                    <Icon
                      icon="contacts"
                      type="outline"
                      width="24px"
                      height="24px"
                      color="#3d3d3d"
                    />
                    <p>{format('metric', report.audience_size)}</p>
                  </div>
                  <div className="last-edited-insights__date">
                    <Icon
                      icon="calendar"
                      type="outline"
                      width="24px"
                      height="24px"
                      color="#3d3d3d"
                    />
                    <p>{format('date', report.updated_at)}</p>
                  </div>
                </Link>
              </Card>
            </For>
          </If>
        </div>
        <If condition={all_reports && all_reports.length > 0}>
          <section>
            <ListView
              className="last-edited-insights__list"
              columns={[
                {
                  key: 'name',
                  name: 'Audience Name',
                  render: (item) => (
                    <ItemInfoCell
                      item={item}
                      key={`item-${item.index}`}
                      link={item.href}
                      actions={(item) =>
                        item.href.includes('/audience') && (
                          <div className="st-item-info-cell__actions">
                            <Button
                              className="st-item-info-cell__action-button"
                              theme={BUTTON_THEME.SECONDARY}
                              size={BUTTON_SIZE.SMALLEST}
                              link={`/audience-creator/${item._id.audience_id ?? item._id}`}
                            >
                              Open in Audience Creator
                              <Icon width="16px" height="16px" icon="externallink" type="outline" />
                            </Button>
                          </div>
                        )
                      }
                    />
                  ),
                  sortable: true,
                  width: 480,
                },
                {
                  format: 'metric',
                  key: 'audience_size',
                  name: 'Size',
                  sortable: true,
                  className: 'last-edited-insights__column',
                },
                {
                  key: 'created_by',
                  name: 'Created by',
                  sortable: false,
                  className: 'last-edited-insights__column',
                },
                {
                  format: 'date',
                  key: 'updated_at',
                  name: 'Last Updated',
                  sortable: true,
                },
              ]}
              data={all_reports}
              filters={[
                {
                  name: 'created_by',
                  placeholder: 'Created by',
                  options,
                  className: 'last-edited-insights__filter',
                },
              ]}
              page_size={page_size}
              search={this.search}
              searchable={false}
              sort_dir={-1}
              sort_key="updated_at"
              title="Last updated insight reports"
              titleClassName="last-edited-insights__title"
              remove_top_pagination
              hideLabel={true}
            />
          </section>
        </If>
      </div>
    )
  }
}

// export
export default LastEditedInsights
